import Module from '../utils/Module';
import PopupModule from "./PopupModule";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default class ExecutivesModule extends Module {
  constructor (options) {
    super(options);

    //this.openPopup = this.openPopup.bind(this);
    //this.closePopup = this.closePopup.bind(this);

    this.popup = new PopupModule(options);
    this.DOMEl = options.element;

    this.viewMoreButtons = this.DOMEl.querySelectorAll('.executive-button-read-more:not(.noclick)');
    this.popupCloseButtons = this.DOMEl.querySelectorAll('.popup-close-button');
    this.linkedinButtons = this.DOMEl.querySelectorAll('.executive-linkedin-link');
    this.bgPopups = this.DOMEl.querySelectorAll('.bg-popup');
    this.executivesCards = this.DOMEl.querySelectorAll(".executive-card");

    this.titleContent = this.DOMEl.querySelector(".executives-module__title");
    this.descriptionContent = this.DOMEl.querySelector(".executives-module__description");
    this.ExecutiveGrid = this.DOMEl.querySelector(".executives-module__grid");

    this.timeline = gsap.timeline().pause();

    this.init();
  }

  init () {
    this.viewMoreButtons.forEach(button =>{
      const closestParentInfosContainer = button.closest(".executive-infos");
      button.addEventListener('click', () => {
        this.popup.openPopup(closestParentInfosContainer);
        this.trackReadBio(closestParentInfosContainer);
      })
    });

    this.popupCloseButtons.forEach(button =>{
      const closestParentInfosContainer = button.closest(".executive-infos");
      button.addEventListener('click', () => {this.popup.closePopup(closestParentInfosContainer)})
    });

    this.linkedinButtons.forEach(link => {
      const closestParentInfosContainer = link.closest(".popup-executive");
      link.addEventListener('click', () => {
        this.trackLinkedinClick(closestParentInfosContainer);
      });
    });

    this.bgPopups.forEach(button =>{
      const closestParentInfosContainer = button.closest(".executive-infos");
      button.addEventListener('click', () => {this.popup.closePopup(closestParentInfosContainer)});
    });

    if(this.titleContent) this.timeline.to(this.titleContent, {css: {'opacity': 1, 'transform': 'translate3d(0,0,0)'}, duration: 0.7, ease: "power2.out"});
    if(this.descriptionContent) this.timeline.to(this.descriptionContent, {css: {'opacity': 1, 'transform': 'translate3d(0,0,0)'}, duration: 0.7, ease: "power2.out"}, '-=0.6');

    const triggerModuleAnimation = ScrollTrigger.create({
      trigger: this.DOMEl,
      start: "top center+=100",
      onEnter: ()=>{
        this.timeline.play();
      },
      onEnterBack: ()=>{
        this.timeline.play();
      }
    });

    const triggerExecutivesAnimation = ScrollTrigger.create({
      trigger: this.ExecutiveGrid,
      start: "top center+=100",
      onEnter: ()=>{
        gsap.to(this.executivesCards, {css: {'opacity': 1, 'transform': 'translate3d(0,0,0)'}, duration: 0.7, ease: "power2.out", stagger:0.2});
      },
      onEnterBack: ()=>{
        gsap.to(this.executivesCards, {css: {'opacity': 1, 'transform': 'translate3d(0,0,0)'}, duration: 0.7, ease: "power2.out", stagger:0.2});
      }
    });
  }

  trackReadBio(executive) {
    dataLayer.push({
      "event": "contentInteraction",
      "interaction": {
        "category": "executive team interaction",
        "action": "accordeon",
        "label": executive.querySelector('.executive-title').textContent
      }
    });
  }

  trackLinkedinClick(executivePopup) {
    dataLayer.push({
      "event": "contentInteraction",
      "interaction": {
        "category": "executive team interaction",
        "action": "linkedin",
        "label": executivePopup.querySelector('.title').textContent
      }
    });
  }
}
